// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkout-form-wizard[data-v-a187e288]  .wizard-tab-content{-webkit-box-shadow:none!important;box-shadow:none!important;background:transparent!important;padding:0}", ""]);
// Exports
module.exports = exports;
